import { ReportType } from "constants/reports/report-type";
import { ApiManager } from "services/api";
import { IActionWithPayload } from "store/helper";

import { IFetchReportPayload } from "../interfaces";

import { makeFetchingSaga } from "./helpers";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* fetchNewTickets(action: IActionWithPayload<string, IFetchReportPayload>) {
  const requests = [
    {
      name: "newTickets",
      interface: ApiManager.reportApi.fetchNewTickets,
    },
    {
      name: "ticketSources",
      interface: ApiManager.reportApi.fetchTicketSources,
    },
  ];

  // @ts-expect-error TS(2345): Argument of type '{ name: string; interface: any; ... Remove this comment to see the full error message
  yield makeFetchingSaga(ReportType.NewTickets, action, requests);
}
